import Vue from "vue";
import CardLargeList from "./components/rest-list/components/CardLargeList.vue";
import CardSmallList from "./components/rest-list/components/CardSmallList.vue";
import RestListHeader from "./components/rest-list/components/RestListHeader.vue";
import PageBanner from "./components/rest-list/components/PageBanner.vue";
import CustomerCart from "./components/rest-list/components/CustomerCart.vue";
import VerifyAddressModal from "./components/rest-list/components/VerifyAddressModal.vue";
import VTooltip from "v-tooltip";
import store from './restListStore/restListIndex';
import "core-js/stable";
import "regenerator-runtime/runtime";
import * as Sentry from "@sentry/vue";
import { Integrations as TracingIntegrations } from "@sentry/tracing";

Vue.use(VTooltip);


if (document.getElementById('verify-address')) {
  new Vue({
    el: "#verify-address",
    name: "VerifyAddressModal",
    components: {
      VerifyAddressModal
    }
  });
} else {
  new Vue({
    el: "#card-large-list",
    name: "CardLargeList",
    store,
    components: {
      CardLargeList
    }
  });
  
  new Vue({
    el: "#card-small-list",
    name: "CardSmallList",
    store,
    components: {
      CardSmallList
    }
  });
  
  new Vue({
    el: "#rest-list-header",
    name: "RestListHeader",
    store,
    components: {
      RestListHeader
    }
  });
  
  new Vue({
    el: "#page-banner",
    name: "PageBanner",
    store,
    components: {
      PageBanner
    }
  });
  
  new Vue({
    el: "#customer-cart",
    name: "CustomerCart",
    store,
    components: {
      CustomerCart
    }
  });
}

Sentry.init({
  Vue: Vue,
  dsn: "https://546797d7309548318f8fedd3582943e9@o211199.ingest.sentry.io/1336256",
  integrations: [new TracingIntegrations.BrowserTracing()],
  tracingOptions: {
    trackComponents: true,
  },
  tracesSampleRate: .1,
  logErrors: true
});